// @flow

import { observer } from "mobx-react";
import React from "react";
import Overlay from "app/components/Overlay/Overlay";
import VideoTitleEditorStore from "app/stores/VideoTitleEditorStore";

import "./VideoTitleEditor.scss";

type Props = {
};

@observer
export default class VideoTitleEditor extends React.Component<Props> {
    handleCancel = () => {
        VideoTitleEditorStore.cancelEditing();
    }

    handleSave = () => {
        VideoTitleEditorStore.saveChanges();
    }

    handleChange = (evt: SyntheticInputEvent<HTMLInputElement>) => {
        VideoTitleEditorStore.setTitle(evt.target.value);
    }

    handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

    setInputRef = (element: ?HTMLInputElement) => {
        if (!element) {
            return null;
        }

        element.select()
        element.focus();
    }

    render() {
        if(!VideoTitleEditorStore.isEditing) {
            return null;
        }

        return (
            <div className="VideoTitleEditor">
                <Overlay active={true} onClick={this.handleCancel}/>

                <div className="VideoTitleEditor__body">
                    <button
                        type="button"
                        onClick={this.handleCancel}
                        className="VideoTitleEditor__cancel"
                    >
                        <i className="fa fa-remove" />
                    </button>

                    <div className="VideoTitleEditor__title">
                        Change title
                    </div>

                    <div className="form-group">
                        <input
                            type="text"
                            value={VideoTitleEditorStore.title}
                            onChange={this.handleChange}
                            className="form-control"
                            ref={this.setInputRef}
                            onKeyUp={this.handleKeyUp}
                            />
                    </div>

                    <button type="button" className="btn btn-success" onClick={this.handleSave}>Save</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/VideoTitleEditor/VideoTitleEditor.js